export const GET_GROUP_OPTIONS = "GET_GROUP_OPTIONS";
export const CLEAR_GROUP_OPTIONS = "CLEAR_GROUP_OPTIONS";
